// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".aceContainer--1oNSiiKV {\n  border: 1px solid #e8e8e8;\n  border-radius: 4px;\n}\n\n.hasError--11Ifzica {\n  border-color: red;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"aceContainer": "aceContainer--1oNSiiKV",
	"hasError": "hasError--11Ifzica"
};
export default ___CSS_LOADER_EXPORT___;
